/*
  Quell canonical form intake controller - Release 4
  Canonical submission schema: quell.attrib/1.0

  One shared, dependency-free controller builds the canonical logical submission
  for every commercial Quell form (contact, quote, remote_tour, showroom and
  design_survey). Attribution and consent are read once, centrally, through the
  Release 3 browser library (window.QuellAttribution, quell.browser-attrib/1.0),
  so no attribution parsing and no per-form CMP interrogation is duplicated.

Release 5 enables the browser-safe canonical route. The controller still
builds and freezes one logical submission, and additionally freezes the
canonical wire body that the deployed n8n intake accepts, so every retry
resends byte-identical bytes under the same transaction_id. qa_test_flag,
legacy suppression and the QA read interface follow the storefront theme
role, so production customer traffic is never flagged as QA.
*/
(function () {
    'use strict';

   if (window.QuellFormIntake) return;

   var SCHEMA_VERSION = 'quell.attrib/1.0';
    var BRAND = 'Quell Workspace';
    var IDEMPOTENCY_SCOPE = 'logical_submission';
var CANONICAL_NETWORK_ENABLED = true;
  /* QUELL-577: the Shopify App Proxy on the shop domain, not the n8n webhook
     directly. Shopify forwards this to the quote app, which attaches the intake
     token server-side. The webhook's only protection was an Origin allowlist,
     and Origin is set by the caller - the bot that reached Zoho through
     /form-to-zoho forged exactly that header. This endpoint creates and updates
     Zoho Contacts, so it needed a secret a page cannot hold.
     Relative on purpose: one value serves quellworkspaces.com and
     quelldesign.ae. Being same-origin also drops the CORS dependency this call
     previously had, while still returning a real status - which matters,
     because the caller below distinguishes 409, 429/5xx and 4xx. */
  var CANONICAL_ENDPOINT = '/apps/quote/attribution';
  var QA_TEST_FLAG = (window.QuellFormIntakeConfig || {}).qa_test_flag === true;
  var SUPPRESS_LEGACY = (window.QuellFormIntakeConfig || {}).suppress_legacy === true;

  /* Release 5 cutover control. legacy_suppressed_forms lets the legacy business
     route be retired one form_source at a time, and canonical_lifecycle_enabled
     is the explicit per-submission opt-in the canonical intake requires before it
     may propagate a Contact. Both are derived from the SAME decision, so the
     legacy route and the canonical lifecycle route are mutually exclusive by
     construction: there can be neither a dual-write nor a gap. Unconfigured or
     older themes send nothing, and the server stays fail-closed (event only). */
  var LEGACY_SUPPRESSED_FORMS = (function () {
    var v = (window.QuellFormIntakeConfig || {}).legacy_suppressed_forms;
    return Object.prototype.toString.call(v) === '[object Array]' ? v : [];
  })();

  function legacySuppressedFor(formSource) {
    if (SUPPRESS_LEGACY === true) return true;
    return !!formSource && LEGACY_SUPPRESSED_FORMS.indexOf(formSource) !== -1;
  }
  /* Release 5 routing separation. The booking service (Calendly) is a required
     business action, not a duplicate CRM destination, so it must never be
     derived from legacy CRM suppression. It has its own explicit switch and
     stays enabled unless a theme opts out deliberately. */
  var BOOKING_ENABLED = (window.QuellFormIntakeConfig || {}).suppress_booking !== true;

  var QA_INSPECT = (window.QuellFormIntakeConfig || {}).qa_inspect === true;
  var ORIGINS = ['url', 'cookie', 'storage', 'referrer', 'unknown', 'stored', 'none', 'legacy_getgclid'];
    var MAX_ATTEMPTS = 3;
    var UNKNOWN = 'UNKNOWN';
    var NOT_CAPTURED = 'NOT_CAPTURED';
    var CLICK_IDS = ['gclid', 'gbraid', 'wbraid'];
    var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
    var FIELD_DENYLIST = /^(utf8|form_type|_gcl_aw|gclid|gbraid|wbraid|utm_source|utm_medium|utm_campaign|utm_term|utm_content)$/i;

   var cfg = window.QuellFormIntakeConfig || {};
    var registry = {};
    var lastController = null;

   /* Release 1-3 NON_EMPTY semantics: empty, whitespace, null, undefined and the
       literal strings 'null' / 'undefined' all mean absent. */
   function nonEmpty(v) {
         if (v === null || v === undefined) return false;
         var s = String(v).trim();
         if (!s) return false;
         var l = s.toLowerCase();
         return l !== 'null' && l !== 'undefined';
   }

   function clean(v) {
         return nonEmpty(v) ? String(v).trim() : '';
   }

   /* Absent optional attribution fields are omitted, never emitted blank, and a
       blank value can never overwrite a value that is already present. */
   function put(target, key, value) {
         if (!nonEmpty(value)) return;
         target[key] = String(value).trim();
   }

   function copy(o) {
         try {
                 return JSON.parse(JSON.stringify(o));
         } catch (e) {
                 return null;
         }
   }

   function iso(ts) {
         try {
                 return new Date(ts || Date.now()).toISOString();
         } catch (e) {
                 return new Date().toISOString();
         }
   }

 /* Browser-native UUIDv4 first, with a crypto-backed fallback and a last-resort
  Math.random fallback for older supported browsers. */
 function uuidv4() {
   try {
     if (window.crypto && typeof window.crypto.randomUUID === 'function') {
       return window.crypto.randomUUID();
     }
     if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
       var b = new Uint8Array(16);
       window.crypto.getRandomValues(b);
       b[6] = (b[6] & 0x0f) | 0x40;
       b[8] = (b[8] & 0x3f) | 0x80;
       var h = [];
       for (var i = 0; i < 16; i++) {
         h.push((b[i] + 0x100).toString(16).slice(1));
       }
       return h.slice(0, 4).join('') + '-' + h.slice(4, 6).join('') + '-' + h.slice(6, 8).join('') + '-' + h.slice(8, 10).join('') + '-' + h.slice(10, 16).join('');
     }
   } catch (e) {}
   return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
     var r = (Math.random() * 16) | 0;
     var v = c === 'x' ? r : (r & 0x3) | 0x8;
     return v.toString(16);
   });
 }

 /* Market comes from the storefront localisation runtime, never from the
  attribution hostname. */
 function marketFor(country) {
   var c = clean(country).toUpperCase();
   if (c === 'GB') return 'UK';
   if (c === 'AE') return 'UAE';
   return c || UNKNOWN;
 }

 /* Reads the route-specific fields the form already collects. Canonical
  attribution belongs in the envelope, so click-ID aliases, UTM aliases,
  _gcl_aw and Shopify form plumbing are never copied into form_payload. */
 function readForm(form) {
   var out = {};
   if (!form || typeof window.FormData !== 'function') return out;
   try {
     new FormData(form).forEach(function (value, key) {
       var name = String(key);
       var bare = name.replace(/^contact\[/, '').replace(/\]$/, '');
       if (FIELD_DENYLIST.test(name) || FIELD_DENYLIST.test(bare)) return;
       if (typeof value !== 'string') return;
       if (!nonEmpty(value)) return;
       out[name] = value.trim();
     });
   } catch (e) {}
   return out;
 }

 /* Attribution is read only through the Release 3 public getters. Nothing is
  re-parsed here and _gcl_aw is never read. window.getGclid() is used solely as
  a backwards-compatibility fallback when the Release 3 library is absent. */
 function attributionSnapshot() {
   var out = {
     browser_schema_version: NOT_CAPTURED,
     attribution_origin: UNKNOWN,
     conflict_status: UNKNOWN,
     current: {},
     first_touch: {},
     current_utm: {},
     first_utm: {}
   };
   var A = window.QuellAttribution;
   var i;
   if (!A || typeof A.getSnapshot !== 'function') {
     out.attribution_origin = NOT_CAPTURED;
     out.conflict_status = NOT_CAPTURED;
     if (typeof window.getGclid === 'function') {
       put(out.current, 'gclid', window.getGclid());
       if (out.current.gclid) out.attribution_origin = 'legacy_getgclid';
     }
     return out;
   }
   var s = A.getSnapshot() || {};
   var f = s.first_utm || {};
   put(out, 'browser_schema_version', s.schema_version);
   put(out, 'attribution_origin', s.attribution_origin);
   put(out, 'conflict_status', s.conflict_status);
   for (i = 0; i < CLICK_IDS.length; i++) {
     put(out.current, CLICK_IDS[i], s[CLICK_IDS[i]]);
     put(out.first_touch, 'first_' + CLICK_IDS[i], s['first_' + CLICK_IDS[i]]);
   }
   for (i = 0; i < UTM_KEYS.length; i++) {
     put(out.current_utm, UTM_KEYS[i], s[UTM_KEYS[i]]);
     put(out.first_utm, UTM_KEYS[i], f[UTM_KEYS[i]]);
   }
   put(out, 'landing_url', s.landing_url);
   put(out, 'landing_hostname', s.landing_hostname);
   if (s.landing_timestamp) out.landing_timestamp = iso(s.landing_timestamp);
   put(out, 'first_landing_url', s.first_landing_url);
   put(out, 'first_landing_hostname', s.first_landing_hostname);
   if (s.first_landing_timestamp) out.first_landing_timestamp = iso(s.first_landing_timestamp);
   return out;
 }

 function tri(v) {
   if (v === true || v === 'yes' || v === 'granted' || v === 'true') return 'granted';
   if (v === false || v === 'no' || v === 'denied' || v === 'false') return 'denied';
   return UNKNOWN;
 }

 /* Consent is captured once, centrally - never per form. The canonical state
  comes from the Release 3 consent interface; the granular storage flags come
  from the already deployed Shopify Customer Privacy API, which is the same
  runtime Release 3 uses. Consentmo remains the CMP identity and is not
  interrogated here, GTM is not read, and window.google_tag_data.ics is not
  used. ad_user_data / ad_personalization follow the visitor's marketing
  consent, except an explicit sale-of-data opt-out (GPC / do-not-sell) forces
  ad_personalization to denied; signals the runtime does not expose stay
  NOT_CAPTURED. Release 4 records consent state only; it does not decide
  Google Ads upload eligibility. */
 function consentSnapshot() {
   var out = {
     state: UNKNOWN,
     interaction: UNKNOWN,
     ad_storage: UNKNOWN,
     analytics_storage: UNKNOWN,
     ad_user_data: NOT_CAPTURED,
     ad_personalization: NOT_CAPTURED,
     preferences_storage: UNKNOWN,
     sale_of_data: UNKNOWN,
     persistence_enabled: false,
     consent_api: NOT_CAPTURED,
     cmp_identity: clean(cfg.cmp_identity) || UNKNOWN,
     cmp_version: clean(cfg.cmp_version) || NOT_CAPTURED,
     region: UNKNOWN,
     timestamp: iso()
   };
   var A = window.QuellAttribution;
   if (A && typeof A.getConsentState === 'function') {
     var st = clean(A.getConsentState());
     if (st) out.state = st;
     if (st === 'granted') out.interaction = 'explicit_grant';
     else if (st === 'denied') out.interaction = 'explicit_denial';
     else if (st) out.interaction = 'no_explicit_decision';
   }
   if (A && typeof A.isPersistenceEnabled === 'function') {
     out.persistence_enabled = !!A.isPersistenceEnabled();
   }
   try {
     var cp = window.Shopify && window.Shopify.customerPrivacy;
     if (cp && typeof cp.currentVisitorConsent === 'function') {
       out.consent_api = 'shopify_customer_privacy';
       var c = cp.currentVisitorConsent() || {};
       out.ad_storage = tri(c.marketing);
       out.analytics_storage = tri(c.analytics);
       out.preferences_storage = tri(c.preferences);
       out.sale_of_data = tri(c.sale_of_data);
       out.ad_user_data = tri(c.marketing);
       out.ad_personalization = tri(c.sale_of_data) === 'denied' ? 'denied' : tri(c.marketing);
       if (typeof cp.getRegion === 'function') {
         var r = clean(cp.getRegion());
         if (r) out.region = r;
       }
     }
   } catch (e) {}
   return out;
 }

 /* Builds the canonical quell.attrib/1.0 envelope. landing_* describes the true
  first landing; the current touch is carried inside attribution. */
 function buildEnvelope(def, formPayload) {
var country = clean(cfg.country_code).toUpperCase() || 'GB';
   var market = marketFor(country);
   var attrib = attributionSnapshot();
   return {
     schema_version: SCHEMA_VERSION,
     brand: BRAND,
brand_market: market,
     form_id: def.formId,
     form_source: def.formSource,
     market: market,
locale: clean(cfg.locale) || ('en-' + country),
     country_code: country,
landing_url: attrib.first_landing_url || attrib.landing_url || window.location.href,
     landing_hostname: attrib.first_landing_hostname || attrib.landing_hostname || window.location.hostname,
     landing_timestamp: attrib.first_landing_timestamp || attrib.landing_timestamp || iso(),
     submit_url: window.location.href,
     submit_timestamp: iso(),
     transaction_id: '',
     idempotency_scope: IDEMPOTENCY_SCOPE,
     qa_test_flag: QA_TEST_FLAG,
     suppress_legacy: SUPPRESS_LEGACY === true,
     canonical_lifecycle_enabled: legacySuppressedFor(def.formSource),
     shop: clean(cfg.shop) || UNKNOWN,
     attribution: attrib,
     consent: consentSnapshot(),
     form_payload: formPayload || {}
   };
 }
  /* Release 5 canonical wire serialiser. The internal envelope above is left
  unchanged; this maps it onto the exact shape the deployed n8n Canonical
  Validation accepts - market-token brand_market, flat click-ID and UTM fields,
  canonical consent enums - and drops browser-internal extras. */
  function consentWire(c) { var sig = function (v) { var s = String(v || '').toLowerCase(); if (s === 'granted') return 'GRANTED'; if (s === 'denied') return 'DENIED'; return 'UNKNOWN'; }; var st = String(c.state || '').toLowerCase(); var out = { state: 'NOT_CAPTURED', interaction: 'no_interaction', ad_storage: sig(c.ad_storage), analytics_storage: sig(c.analytics_storage), ad_user_data: sig(c.ad_user_data), ad_personalization: sig(c.ad_personalization), security_storage: sig(c.security_storage) }; if (st === 'granted') { out.state = 'EXPLICIT_GRANTED'; out.interaction = 'accepted_all'; } if (st === 'denied') { out.state = 'EXPLICIT_DENIED'; out.interaction = 'rejected_all'; } put(out, 'timestamp', c.timestamp); put(out, 'cmp_name', c.cmp_identity); put(out, 'cmp_version', c.cmp_version); put(out, 'region', c.region); put(out, 'snapshot_source', c.consent_api); return out; }
  function wirePayload(env) { var a = env.attribution || {}; var cur = a.current || {}; var ft = a.first_touch || {}; var cu = a.current_utm || {}; var fu = a.first_utm || {}; var w = { schema_version: env.schema_version, brand: env.brand, brand_market: env.brand_market, form_id: env.form_id, form_source: env.form_source, market: env.market, locale: env.locale, country_code: env.country_code, landing_url: env.landing_url, landing_hostname: env.landing_hostname, landing_timestamp: env.landing_timestamp, submit_url: env.submit_url, submit_timestamp: env.submit_timestamp, transaction_id: env.transaction_id, idempotency_scope: env.idempotency_scope, qa_test_flag: env.qa_test_flag === true, suppress_legacy: env.suppress_legacy === true, canonical_lifecycle_enabled: env.canonical_lifecycle_enabled === true, consent: consentWire(env.consent || {}), form_payload: env.form_payload || {} }; var i; for (i = 0; i < CLICK_IDS.length; i++) { put(w, CLICK_IDS[i], cur[CLICK_IDS[i]]); put(w, 'first_' + CLICK_IDS[i], ft['first_' + CLICK_IDS[i]]); } for (i = 0; i < UTM_KEYS.length; i++) { put(w, UTM_KEYS[i], cu[UTM_KEYS[i]]); put(w, 'first_' + UTM_KEYS[i], fu[UTM_KEYS[i]]); } var origin = String(a.attribution_origin || '').toLowerCase(); if (ORIGINS.indexOf(origin) >= 0) w.attribution_origin = origin; return w; }
  
function Controller(def) {
  this.def = def;
  this.state = 'idle';
  this.submission = null;
  this.attempts = 0;
}

Controller.prototype.snapshot = function () {
  if (!this.submission) return null;
  return {
    form_id: this.def.formId,
    transaction_id: this.submission.transaction_id,
    state: this.state,
    attempts: this.attempts,
    bytes: this.submission.bytes,
    prepared_at: this.submission.prepared_at,
    network_enabled: CANONICAL_NETWORK_ENABLED,
    payload: copy(this.submission.payload)
  };
};

/* One logical submission owns one transaction_id. prepare() snapshots the
attribution, the consent state and the form payload once and freezes them.
Every later call while that submission is still active - repeated click,
retry, timeout, lost response - returns the same frozen submission and never
mints a new UUID. A new transaction_id is issued only after the previous
logical submission has finished and the user intentionally starts another. */
Controller.prototype.prepare = function () {
  if (this.submission && this.state === 'submitting') {
    return { accepted: false, reused: true, reason: 'in_flight', submission: this.snapshot() };
  }
  if (this.submission && (this.state === 'prepared' || this.state === 'failed_retryable')) {
    return { accepted: true, reused: true, reason: 'reused', submission: this.snapshot() };
  }
  var payload = {};
  try {
    payload = (this.def.buildFormPayload ? this.def.buildFormPayload() : {}) || {};
  } catch (e) {
    payload = {};
  }
  var env = buildEnvelope(this.def, payload);
  env.transaction_id = uuidv4();
  var serialised = '';
  var frozen = null;
  try {
    serialised = JSON.stringify(env);
    frozen = JSON.parse(serialised);
  } catch (e) {
    this.state = 'failed_terminal';
    return { accepted: false, reused: false, reason: 'serialisation_error', submission: null };
  }
  if (typeof Object.freeze === 'function') Object.freeze(frozen);
var wired = null; var wireBody = '';
  try { wired = JSON.parse(JSON.stringify(wirePayload(frozen))); wireBody = JSON.stringify(wired); } catch (e) { wired = null; }
  if (!wired) { this.state = 'failed_terminal'; return { accepted: false, reused: false, reason: 'serialisation_error', submission: null }; }
  if (typeof Object.freeze === 'function') Object.freeze(wired);
  this.submission = { transaction_id: frozen.transaction_id, payload: frozen, wire: wired, body: wireBody, bytes: wireBody.length, prepared_at: frozen.submit_timestamp };
  this.attempts = 0;
  this.state = 'prepared';
  lastController = this;
  return { accepted: true, reused: false, reason: 'prepared', submission: this.snapshot() };
};

/* Transport contract. Release 4 ships with the canonical network disabled, so
send() resolves as a dry run and nothing leaves the browser. The contract is
defined now so Release 5 only has to supply the endpoint and flip the flag:
the same transaction_id and the same frozen payload on every attempt; one
in-flight attempt at a time; at most MAX_ATTEMPTS attempts; retry only on
timeout / 429 / 5xx; never retry a 4xx validation error; never resend a 409
idempotency conflict as a new submission; success only after a truthful 2xx
response, so mode 'no-cors' is never used. */
Controller.prototype.attempt = function () {
  var self = this;
  if (!this.submission) {
    return Promise.resolve({ ok: false, terminal: true, reason: 'not_prepared' });
  }
  if (this.state === 'submitting') {
    return Promise.resolve({ ok: false, terminal: false, reason: 'in_flight', transaction_id: this.submission.transaction_id });
  }
  if (this.state === 'succeeded') {
    return Promise.resolve({ ok: true, terminal: true, reason: 'already_succeeded', transaction_id: this.submission.transaction_id });
  }
  if (this.attempts >= MAX_ATTEMPTS) {
    this.state = 'failed_terminal';
    return Promise.resolve({ ok: false, terminal: true, reason: 'attempts_exhausted', transaction_id: this.submission.transaction_id });
  }
  this.attempts++;
  this.state = 'submitting';
  if (!CANONICAL_NETWORK_ENABLED || !CANONICAL_ENDPOINT) {
    this.state = 'prepared';
    return Promise.resolve({ ok: true, terminal: false, mode: 'dry_run', reason: 'canonical_network_disabled', attempt: this.attempts, transaction_id: this.submission.transaction_id });
  }
  return fetch(CANONICAL_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
body: this.submission.body
  }).then(function (res) {
    var status = res.status;
    if (status === 409) {
      self.state = 'failed_terminal';
      return { ok: false, terminal: true, reason: 'idempotency_conflict', status: status };
    }
    if (status === 429 || status >= 500) {
      self.state = 'failed_retryable';
      return { ok: false, terminal: false, reason: 'retryable_status', status: status };
    }
    if (status >= 400) {
      self.state = 'failed_terminal';
      return { ok: false, terminal: true, reason: 'validation_error', status: status };
    }
    if (res.ok) {
      self.state = 'succeeded';
      return { ok: true, terminal: true, reason: 'accepted', status: status, transaction_id: self.submission.transaction_id };
    }
    self.state = 'failed_terminal';
    return { ok: false, terminal: true, reason: 'unexpected_status', status: status };
  }).catch(function () {
    self.state = 'failed_retryable';
    return { ok: false, terminal: false, reason: 'network_error' };
  });
};
/* Release 5 bounded retry wrapper. Same transaction_id and same frozen wire
payload on every attempt; retries only a transient transport error or a 429 /
5xx; never retries a 4xx validation error and never resends a 409 conflict. */
  Controller.prototype.send = function () { var self = this; var again = function (r) { if (r && !r.ok && r.terminal === false && (r.reason === 'retryable_status' || r.reason === 'network_error') && self.attempts < MAX_ATTEMPTS) { return self.send(); } return r; }; return self.attempt().then(again); };
  
/* Closes the logical submission so the next intentional submission receives a
new transaction_id. */
Controller.prototype.finish = function (outcome) {
  this.state = outcome === 'succeeded' ? 'succeeded' : 'failed_terminal';
  return this.state;
};

Controller.prototype.reset = function () {
  this.state = 'idle';
  this.submission = null;
  this.attempts = 0;
};

window.QuellFormIntake = {
  schemaVersion: SCHEMA_VERSION,
  brand: BRAND,
  idempotencyScope: IDEMPOTENCY_SCOPE,
  qaTestFlag: QA_TEST_FLAG,
  maxAttempts: MAX_ATTEMPTS,
networkEnabled: function (formSource) {
    var fs = formSource || (lastController && lastController.def ? lastController.def.formSource : null);
    return CANONICAL_NETWORK_ENABLED && !!CANONICAL_ENDPOINT && !legacySuppressedFor(fs);
  },
  lifecycleEnabledFor: function (formSource) { return legacySuppressedFor(formSource); },
  legacySuppressedForms: function () { return LEGACY_SUPPRESSED_FORMS.slice(); },
  bookingEnabled: function () { return BOOKING_ENABLED; },
  canonicalEnabled: function () { return CANONICAL_NETWORK_ENABLED && !!CANONICAL_ENDPOINT; },
  canonicalEndpoint: CANONICAL_ENDPOINT,
  readForm: readForm,
  register: function (def) {
    if (!def || !def.formId) return null;
    if (!registry[def.formId]) registry[def.formId] = new Controller(def);
    return registry[def.formId];
  },
  get: function (formId) {
    return registry[formId] || null;
  },
};
  /* QA-only read interface. It is attached only when the storefront reports a
  non-live theme role, returns a deep copy rather than the live state, logs
  nothing automatically, and is therefore absent from production. */
  if (QA_INSPECT) { window.QuellFormIntake.getLastPreparedSubmission = function () { return lastController ? lastController.snapshot() : null; }; }
  if (QA_INSPECT) { window.QuellFormIntake.getPreparedSubmission = function (formId) { return registry[formId] ? registry[formId].snapshot() : null; }; }
})();
